import styled from 'styled-components';

const BackgroundContainer = styled.div`
    width: 100vw;
    height: 100vh;
    background: url('/images/background.jpg') no-repeat center / cover;
`;

export default BackgroundContainer;
